export default "__VITE_ASSET__CyTzzA2k__"